import { PureComponent } from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import './DebugHelper.css';

const propTypes = {
  ravenLastEventId: PropTypes.string,
};

const defaultProps = {
  ravenLastEventId: null,
};

class DebugHelper extends PureComponent {
  render() {
    const { ravenLastEventId, className, ...otherProps } = this.props;
    return (
      <div className={clsx('DebugHelper', className)} {...otherProps}>
        <p className="DebugHelper-title">UAT Event ID</p>
        <div className="DebugHelper-ravenLastEventId">
          <code>{ravenLastEventId}</code>
        </div>
      </div>
    );
  }
}

DebugHelper.propTypes = propTypes;
DebugHelper.defaultProps = defaultProps;

export default DebugHelper;
